/* istanbul ignore file */
import { EnumField } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { getLabel } from 'framework/utils';
import { INDUSTRIES } from 'domain/sales/salesService';

type IndustryFieldProps = {
  value?: string;
  source: string;
  label?: string;
};

const IndustryField = ({ value: inputValue, source, label }: IndustryFieldProps) => {
  const { data } = useShowContext();

  const value = inputValue || (data && data.getValueBySource(source));

  return <EnumField value={value} options={INDUSTRIES} label={getLabel(label, source)} />;
};

export default IndustryField;
